import type { PropType } from 'virtual-vue';
import type { SwitchSize } from './switch';

/**
 * 组件的 props
 */
export const props = {
  /** 当前选中标签的索引 - 仅vue3可用 */
  modelValue: {
    type: Boolean,
    default: false,
  },
  /**
   * 开关状态
   * @default false
   */
  value: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否禁用
   * @default false
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * 尺寸大小
   * @default 'large'
   */
  size: {
    type: String as PropType<SwitchSize>,
    default: 'large',
    validator: (value: string) => ['small', 'large'].includes(value),
  },
};
